import Swal from 'sweetalert2'

import { routes } from '../config'
import extrasFiles from '../extrasFiles'
import { decodeExtraFieldsKeys } from '../extrasFiles/utils'
import { tips } from '../locales'
import request from '../request'
import store from '../store'
import { setGlobalIsPending, setPaymentMethods } from '../store/actions'
import { constants, storage } from '../utils'
import Base64 from '../utils/base64'


const setB3PaymentMethods = async (companyId: string) => {

  if (storage.IPCheckout.getValue() === '1') {
    const { allowedMethods } = await request.api.getIPPaymentMethods()

    store.dispatch(setPaymentMethods(allowedMethods))

    return
  }

  const methods = await request.api.getPaymentMethods(companyId)

  const enabledMethods = methods.filter(method => method.isEnabled === constants.B3PaymentMethodPermission.isEnabled)

  store.dispatch(setPaymentMethods(enabledMethods))
}

const getSelectAddressId = (address: any, mode: string, extraFields: any[]) => {
  if (!address) return ''

  const {
    company: companyAddresses
  } = store.getState()

  const storageKey =  mode === 'billing' ? 'selectBillAddressId' : 'selectShoppingAddressId'
  const addressId = storage[storageKey].getValue()

  const b3Address: any = companyAddresses.addresses.find((item: any) => +item?.addressId === +addressId && +item[mode === 'billing' ? 'isBilling' : 'isShipping'] === 1) || ''

  let isFlag = true

  if (extraFields?.length && b3Address) {
    const {
      extraFields: b2bExtraFields
    } = b3Address

    isFlag = b2bExtraFields.every((item: any) => {
      const extraField: any = extraFields.find((field) => Base64.decode(item.fieldName) === field.fieldName && item.fieldValue === field.fieldValue) || ''

      return !!extraField
    })
  }

  if (b3Address && isFlag) {
      isFlag = Object.keys((address )).every((key: string) => {
          if (key === 'shouldSaveAddress' || key === 'id' || key === 'email' || key === 'stateOrProvinceCode') return true
          if (key === 'customFields') return !((address )?.customFields || []).length
          if ((address )[key] === b3Address[key] || ((address )[key] === '')) return true

          return false
      })
  }

  return isFlag ? addressId : ''

}

const addPoNumber = async (orderId: any, billingAddress: any, shippingAddress: any) => {
  const poNumber = storage.B3PoNumber.getValue() || ''
  const referenceNumber = storage.B3PaymentsAdditionalTextFieldValue.getValue() || ''

  let extraFields: any = []
  const customFields = JSON.parse(localStorage.getItem('B3PaymentCustomFields') || '{}')
  const decodeExtraFieldsKey = decodeExtraFieldsKeys(customFields)

  if (customFields && JSON.stringify(customFields) !== '{}') {
    extraFields = Object.keys(decodeExtraFieldsKey).map((item: any) => {
      return {
        fieldName: item,
        fieldValue: decodeExtraFieldsKey[item]
      }
    })
  }

  const extraInfo = extrasFiles.getShippingAndBillingFields()

  const saveBillingAddressId = getSelectAddressId(billingAddress, 'billing', extraInfo?.addressExtraFields?.billingAddressExtraFields || [])
  const saveShoppingAddressId = getSelectAddressId(shippingAddress, 'shopping', extraInfo?.addressExtraFields?.shippingAddressExtraFields || [])

  if (saveBillingAddressId) extraInfo.billingAddressId = +saveBillingAddressId
  if (saveShoppingAddressId) extraInfo.shipppingAddressId = +saveShoppingAddressId

  if (!orderId) return

  try {
    store.dispatch(setGlobalIsPending(true))
    await request.api.addPoNumber({
      orderId,
      poNumber,
      referenceNumber,
      extraFields,
      extraInfo,
    })
  }
  finally {
    store.dispatch(setGlobalIsPending(false))
    storage.B3PoNumber.removeValue()
    storage.B3OrderExtras.removeValue()
    storage.B3BillingAddressExtras.removeValue()
    storage.B3ShippingAddressExtras.removeValue()
    storage.B3DefaultAddressExtras.removeValue()
    storage.B3IsInitShippingAndBillingAddress.removeValue()
    storage.B3PaymentsAdditionalTextFieldValue.removeValue()
    storage.selectShoppingAddressId.removeValue()
    storage.selectBillAddressId.removeValue()
    localStorage.removeItem('B3PaymentCustomFields')
    localStorage.removeItem('B3ShippingCustomFields')
    localStorage.removeItem('B3BillingCustomFields')
  }
}

const checkoutQuote = async (orderId: any, storeHash: string, checkout: any,) => {
  const quoteId = storage.quoteCheckoutId.getValue()

  if (!orderId || !quoteId) return

  const { consignments, shippingCostTotal, taxTotal } = checkout

  const isNumberProduct = !consignments.length || !consignments[0]?.shippingAddress
  const params = {
    orderId,
    storeHash,
    shippingTotal: isNumberProduct ? null : shippingCostTotal,
    taxTotal,
    shippingMethod: isNumberProduct ? null : consignments[0].selectedShippingOption,
    shippingAddress: isNumberProduct ? null : {
      country: consignments[0].shippingAddress.country,
      state: consignments[0].shippingAddress.stateOrProvince,
      city: consignments[0].shippingAddress.city,
      zipCode: consignments[0].shippingAddress.postalCode,
      address: consignments[0].shippingAddress.address1,
      apartment: consignments[0].shippingAddress.address2,
      firstName: consignments[0].shippingAddress.firstName,
      lastName: consignments[0].shippingAddress.lastName,
    },
  }

  try {
    store.dispatch(setGlobalIsPending(true))
    await request.api.checkoutQuote(quoteId, params)
  }
  finally {
    store.dispatch(setGlobalIsPending(false))
    storage.quoteCheckoutId.removeValue()
  }
}

const getIPOrderPaymentId = async (orderId: any) => {
  try {
    store.dispatch(setGlobalIsPending(true))

    const comment = storage.B3IPComment.getValue() || ''

    const { receiptId } = await request.api.getIPOrderPaymentId({ orderId, comment })

    storage.B3IPComment.removeValue()

    let href = `${location.origin}/invoice-payment-receipt/?id=${receiptId}`

    if ((window as any)?.B3?.setting?.b2b_url) {
      href = `${location.origin}/#/invoice?receiptId=${receiptId}`
    }

    window.location.href = href
  }
  finally {
    store.dispatch(setGlobalIsPending(false))
    storage.IPCheckout.removeValue()
    localStorage.removeItem('invoicePay')
  }
}

export const paySubmit = async (order: any, storeHash: any, checkout: any, billingAddress: any, shippingAddress: any) => {
  let isInvoice = false
  const {
    global: {
      isB3User
    }
  } = store.getState()

  if (isB3User && storage.IPCheckout.getValue() !== '1') {
    await addPoNumber(order.orderId, billingAddress, shippingAddress)
  }

  const quoteId = storage.quoteCheckoutId.getValue() || ''

  quoteId && await checkoutQuote(order.orderId, storeHash, checkout)

  if (storage.IPCheckout.getValue() === '1') {
    await getIPOrderPaymentId(order.orderId)
    isInvoice = true
  }

  storage.B3OrderExtras.removeValue()
  storage.quoteDate.removeValue()
  storage.quoteCheckoutId.removeValue()

  return isInvoice
}

const init = async () => {
  const {
    global: {
      isB3User
    }
  } = store.getState()

  if (!isB3User) return

  const companyId = storage.B3CompanyId.getValue()

  if (!companyId) {
    await Swal.fire({
      icon: 'error',
      text: tips['b3.salesRep.notMasquerading'],
      allowOutsideClick: false,
      allowEscapeKey: false,
    })
    location.href = routes.dashboard

    return Promise.reject()
  }

  setB3PaymentMethods(companyId)
}

export default {
  init,
  addPoNumber,
  checkoutQuote,
  getIPOrderPaymentId,
  paySubmit,
  getSelectAddressId,
}